export default "__VITE_ASSET__D4sTr743__"